<template>
  <div
    class="document"
    :class="{ 'document--sm': isSmall }"
  >
    <v-checkbox
      v-if="checkbox"
      :id="id"
      :checked="isSelected"
      is-mini
      @change="selectAction"
    />
    <v-icon
      v-if="icon"
      class="document__icon"
      :type="icon"
    />
    <span
      class="document__title"
      :title="title"
    >{{ title }}</span>
    <v-button
      class="document__link"
      color="transparent"
      @click="$emit('click', link)"
    >
      <v-icon 
        type="download" 
      />
    </v-button>
    <v-button
      v-if="canDelete"
      class="document__link"
      color="transparent"
      @click="$emit('delete')"
    >
      <v-icon
        type="trash"
      />
    </v-button>
    <small
      v-if="updated"
      class="document__updated"
      :title="'Last updated ' + updated"
    >{{ updated }}</small>
  </div>
</template>

<script>
  import Icon from "@/atoms/Icon";
  import Button from "@/atoms/Button";
  import Checkbox from "@/atoms/Checkbox";
  export default {
    components: {
      "v-icon": Icon,
      "v-button": Button,
      "v-checkbox": Checkbox,
    },
    props: {
      id: {
        type: [String,Number],
        default: null,
      },
      title: {
        type: String,
        default: null,
        required: true
      },
      link: {
        type: String,
        default: ''
      },
      icon: {
        type: String,
        default: null
      },
      isSmall: {
        type: Boolean,
        default: false
      },
      checkbox: {
        type: Boolean,
        default: false,
      },
      selectAction: {
        type: Function,
        default: null
      },
      isSelected: {
        type: [Boolean, Number],
        default: false
      },
      canDelete: {
        type: [Boolean, Number],
        default: false
      },
      updated: {
        type: String,
        default: null
      },
    }
  };
</script>

<style lang="scss">
	@import "../../styles/shared/shared";
	.document {
    $this: &;
		display: flex;
		padding-top: .25rem;
		padding-bottom: .25rem;
    border-bottom: solid 1px $zircon;
    align-items: center;
    flex-wrap:wrap;
    color: $tangaroa;
		&__link {
			margin-left: auto;
			font-size: 1.25em;
		}
		&__icon {
			margin-right: .5rem;
			font-size: 1.25em;
			align-self: flex-start;
		}
		&__title {
			margin-right: .5rem;
			flex: 1;
      word-break: break-word;
      hyphens: auto;
		}
    &__updated {
      flex-basis:100%;
    }
    &--sm {
      display: inline-flex;
      font-size: $font-size-sm;
      background-color: $primary;
      color: $white;
      border-radius: 1rem;
      padding: .25em .5em;
      #{$this}__link {
        padding: 0;
        color: $white;
      }
      & + & {
        margin-left: .5em;
      }
    }
	}
</style>


